/**
 * Frontend mirror of server invoice edit window (default 2h; keep in sync with INVOICE_TASK_EDIT_WINDOW_HOURS).
 */
export const INVOICE_TASK_EDIT_WINDOW_HOURS = 2;

export function getInvoiceEditAnchor(invoice) {
  if (!invoice) return null;
  return invoice.issue_date || invoice.createdAt || null;
}

export function isInvoiceEditWindowOpen(invoice, now = new Date()) {
  if (!invoice) return false;
  if (invoice.status === 'credited' || invoice.status === 'refunded') return false;
  const anchor = getInvoiceEditAnchor(invoice);
  if (!anchor) return false;
  const anchorDate = anchor instanceof Date ? anchor : new Date(anchor);
  if (isNaN(anchorDate.getTime())) return false;
  const elapsedMs = now.getTime() - anchorDate.getTime();
  return elapsedMs < INVOICE_TASK_EDIT_WINDOW_HOURS * 60 * 60 * 1000;
}

export function getInvoiceEditWindowEnd(invoice) {
  const anchor = getInvoiceEditAnchor(invoice);
  if (!anchor) return null;
  const anchorDate = anchor instanceof Date ? anchor : new Date(anchor);
  if (isNaN(anchorDate.getTime())) return null;
  return new Date(anchorDate.getTime() + INVOICE_TASK_EDIT_WINDOW_HOURS * 60 * 60 * 1000);
}

export function canEditInvoiceLine(task, invoice, now = new Date()) {
  if (!task?.task_billed || task.task_credited) return false;
  if (!task.related_invoice || !invoice) return false;
  return isInvoiceEditWindowOpen(invoice, now);
}
